import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useGlobalSettingsState = createStateHook(
  AppStoreProvider,
  state => state.pages.globalSettings
)
export const useNextGlobalSettingsState = () =>
  createNextHook(AppStoreProvider, state => state.pages.globalSettings)
